import { ALL_PLACES } from './planning-places'
import {
  oneOf,
  selectedKeyFilter,
  stringFilter,
} from '@/components/Internal/DataTable'

/** Which half of the tab the screen is on. */
export type PlanningTab = 'object' | 'positions' | 'configurator'

export const planningListFilters = {
  search: stringFilter(),

  /** `null` opens the building's own pane, which is what a screen with
   *  nothing selected shows. */
  selected: selectedKeyFilter(),

  /** Which place the position list is narrowed to — a room's id, `house`, or
   *  the sentinel that widens it to all of them. */
  place: stringFilter(ALL_PLACES),

  /** The open position — a row key of the positions list. */
  position: selectedKeyFilter(),

  /** The open configurator step. Its own filter rather than `selected`: both
   *  tabs are addressable at once, and neither may reopen the other's row. */
  question: {
    ...stringFilter(),
    countsAsFilter: false,
    resettable: false,
  },

  /** Rides in the query string so the tab is part of the address; it narrows
   *  nothing and survives a filter reset. */
  tab: {
    ...oneOf<PlanningTab>(['object', 'positions', 'configurator'], 'object'),
    countsAsFilter: false,
    resettable: false,
  },
}
